import { Pipe, PipeTransform } from '@angular/core';
 
@Pipe({
    name: 'pricetext'
})
export class PriceTextPipe implements PipeTransform {
  transform(value: number, args?: any): String {
   return this.getPrice(value);
  }
   getPrice(x: number): string {
    if (x > 100000) {
        let newX: number = Math.round(x / 1000);
        let parts = String(newX).split(".");
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return parts.join(".") + "K";
    }
    else {
        let parts = String(x).split(".");
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return parts.join(".");
    }
}

}


// WEBPACK FOOTER //
// ./src/app/components/pipes/price-textpipe.ts